<div class="locations-card">
<loading [isLoading]="isLoading"></loading>
    <div class="locations-card-top">
        <div class="top-left">
            <h2>Activos con GPS</h2>
            <p><span>{{totalLocationsByGPS}}</span> Asignados</p>
        </div>

        <div class="top-right">
           <mat-icon class="icon">gps_fixed</mat-icon>
        </div>

    </div>

    <div class="locations-card-bottom">
    
        <div class="online-section">
            <div class="bar-text">
                <h3>{{ online }}</h3>
                <p>Online</p>
            </div>
            <div class="bar-container">
                <span *ngIf="onlinePercent > 0">{{ onlinePercent }}%</span>
                <div class="online-bar" [ngStyle]="{ width: onlinePercent + '%' }">
                    <!-- <span *ngIf="onlinePercent > 0">{{ onlinePercent }}%</span> -->
                </div>
            </div>
        </div>
    
        <div class="offline-section">
            <div class="bar-text">
                <h3>{{ offline }}</h3>
                <p>Offline</p>
            </div>
            <div class="bar-container">
                <div class="offline-bar" [ngStyle]="{ width: offlinePercent + '%' }">
                    <span *ngIf="offlinePercent > 0">{{ offlinePercent }}%</span>
                </div>
            </div>
        </div>
    
        <div class="noReport-section">
            <div class="bar-text">
                <h3>{{ noReport }}</h3>
                <p>No Report</p>
            </div>
            <div class="bar-container">
                <div class="noReport-bar" [ngStyle]="{ width: noReportPercent + '%' }">
                    <span *ngIf="noReportPercent > 0">{{ noReportPercent }}%</span>
                </div>
            </div>
        </div>
    
    </div>
</div>